import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpBackend, HttpClient , HttpClientModule , HTTP_INTERCEPTORS ,HttpClientXsrfModule} from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class BookingService {
  constructor(public http: HttpClient,public handler: HttpBackend) { }

  /**
   * @method { getAllBusiness API call }
   * @param params
   */

   async setTime(date, h, m, s) {
    await date.setHours(h);
    await date.setMinutes(m);
    await date.setSeconds(s);
    let utcDate = new Date(date).toISOString();
    return utcDate;
  }

  getAllappointments(params:any) {
    return this.http
      .get(`${environment.bookingBaseUrl}admin/appointments` , {params :params})
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  getOrderDetails(code:any) {
    return this.http
      .get(`${environment.bookingBaseUrl}order_details/${code}` )
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }
  


  delete_all() {
    return this.http
      .delete(`${environment.bookingBaseUrl}admin/delete_all`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  getTimeByDayId(id:any) {
    return this.http
      .get(`${environment.bookingBaseUrl}admin/working_times/day/${id}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }


  getWorkingDays(params:any) {
    return this.http
      .get(`${environment.bookingBaseUrl}admin/working_days` , {params :params})
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }


  ChangeAppointmentStatus(params: any) {
    return this.http
      .put(`${environment.bookingBaseUrl}admin/appointments/change-status` ,  params)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  addDateTime(params: any) {
    return this.http
      .post(`${environment.bookingBaseUrl}admin/working_days/time` ,  params)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }






  addTimeToDay(params: any) {
    return this.http
      .post(`${environment.bookingBaseUrl}working_times` ,  params)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }


  changePaymentStatus(params: any) {
    return this.http
      .put(`${environment.bookingBaseUrl}admin/appointments/change-payment-status` ,  params)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  DeleteAppointments(id:any) {
    return this.http
      .delete(`${environment.bookingBaseUrl}admin/appointments/${id}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  DeleteWorkingDays(id:any) {
    return this.http
      .delete(`${environment.bookingBaseUrl}admin/working_days/${id}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  getStatistics(params) {
    return this.http
      .get(`${environment.bookingBaseUrl}admin/statistics` ,{params :params})
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

}
